module.exports = __webpack_public_path__ + "img/product_72.3252f32.webp";